import React from "react";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Card,
  Group,
  ScrollArea,
  Table,
  Text,
  TextInput,
} from "@mantine/core";
import { IconEdit, IconEye, IconPlus, IconSearch } from "@tabler/icons-react";
import { useGetOrganizations } from "api/superAdmin/organizationManagement";
import ActionsBtn from "../../actionBtn/actionBtn";

export default function TableSystem() {
  const [page, setPage] = React.useState(1);
  const limit = 10;

  const { data, isLoading, error } = useGetOrganizations(page, limit);
  const colors = ["#5c4bff", "#00b894", "#e17055"];
  const cols = ["purple", "green", "orange"];
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading organizations.</div>;

  return (
    <Card shadow="sm" radius="md" p="lg" mb={30}>
      <Group position="apart" mb="md">
        <Text weight={700}>System</Text>
        <Group>
          <TextInput
            placeholder="Search organizations..."
            icon={<IconSearch size={16} />}
            radius="md"
          />
          <Button leftIcon={<IconPlus size={16} />} radius="md" color="violet">
            Add Organization
          </Button>
        </Group>
      </Group>
      <ScrollArea>
        <Table verticalSpacing="md">
          <thead>
            <tr>
              <th>Organization</th>
              <th>Type</th>
              <th>Employees</th>
              {/* <th>Projects</th> */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.organizations.map((o, ind) => (
              <tr key={o.id}>
                <td>
                  <Group spacing="sm">
                    <Box
                      sx={{
                        backgroundColor: colors[ind % colors.length],
                        borderRadius: "8px",
                        padding: "8px 12px",
                      }}
                    >
                      <Text weight={700} color="white">
                        {o.name ? o.name.trim().charAt(0).toUpperCase() : ""}
                      </Text>
                    </Box>
                    <Box>
                      <Text fw={600}>{o.name}</Text>
                      {/* <Text size="sm" c="dimmed">
                        {o.members.map((email) => email.email)}
                      </Text> */}
                    </Box>
                  </Group>
                </td>
                <td>{o.type}</td>
                <td>{o.employees}</td>
                {/* <td>{o.projects}</td> */}

                <td>
                  <ActionsBtn />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ScrollArea>
    </Card>
  );
}
